import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import * as Bowser from "bowser";
import { BehaviorSubject, filter } from 'rxjs';
import { isMobileSize, isTabletSize, isDesktopSize, isTabletAndBeyondSize, isTabletAndBelowSize } from '../utils/bowser.util';
import { IBrowserDetails, IClientPlatform } from '../models/client-platform.model';
import { isNotNull } from '../utils/type-guards.util';

@Injectable({ providedIn: 'root' })
export class ClientPlatformService {

  private bowser;
  private maxTouchPoints;
  private windowWidth: BehaviorSubject<number | null>  = new BehaviorSubject(1368);  //intitial desktop width
  windowWidth$ = this.windowWidth.asObservable();

  private clientPlatform: BehaviorSubject<IClientPlatform | null> = new BehaviorSubject(null);
  clientPlatform$ = this.clientPlatform.asObservable();
  
  isMobileScreenSize$ = this.windowWidth$.pipe(isMobileSize());
  isTabletScreenSize$ = this.windowWidth$.pipe(isTabletSize());
  isDesktopScreenSize$ = this.windowWidth$.pipe(isDesktopSize());
  isTabletAndBeyondSize$ = this.windowWidth$.pipe(isTabletAndBeyondSize());
  isTabletAndBelowSize$ = this.windowWidth$.pipe(isTabletAndBelowSize());

  constructor(
    @Inject(PLATFORM_ID) private _platformId: string,
  ) { 
    if (isPlatformBrowser(this._platformId)) {
      this.bowser = Bowser.parse(window.navigator.userAgent);
      this.maxTouchPoints = window.navigator.maxTouchPoints
      this.clientPlatform.next({ browserDetails: { ...this.bowser, maxTouchPoints: this.maxTouchPoints } as IBrowserDetails, isValid: true });
      this.windowWidth.next(window.innerWidth);
    }
  }

  updateWindowWidth(screenSize: number) {
    this.windowWidth.next(screenSize)
  }

}
